import React, { useState } from "react";
import "../../assests/css/CityTour.css";

function CityTour() {

    // =====================================================
    // FORM STATES
    // =====================================================

    const [pickup, setPickup] = useState("");
    const [destination, setDestination] = useState("");

    const [tourDate, setTourDate] = useState("");
    const [tourTime, setTourTime] = useState("");

    const [passengers, setPassengers] =
        useState("1 Passenger");

    const [duration, setDuration] =
        useState("4 Hours");

    const [vehicle, setVehicle] =
        useState("Luxury Sedan");


    // =====================================================
    // BOOKING
    // =====================================================

    const handleBooking = (event) => {

        event.preventDefault();


        // =================================================
        // CLEAN TEXT VALUES
        // =================================================

        const cleanPickup = pickup.trim();
        const cleanDestination = destination.trim();


        // =================================================
        // CHECK ALL FIELDS
        // =================================================

        if (
            !cleanPickup ||
            !cleanDestination ||
            !tourDate ||
            !tourTime ||
            !passengers ||
            !duration ||
            !vehicle
        ) {

            alert(
                "Please fill in all City Tour booking fields."
            );

            return;
        }


        // =================================================
        // WHATSAPP MESSAGE
        // =================================================

        const message = `
Hello Prime Luxury,

I would like to book a Dubai City Tour.

*Pickup Location:*
${cleanPickup}

*Tour Destination:*
${cleanDestination}

*Tour Date:*
${tourDate}

*Pickup Time:*
${tourTime}

*Passengers:*
${passengers}

*Tour Duration:*
${duration}

*Vehicle Type:*
${vehicle}

Please confirm the availability and booking details.

Thank you.
        `;


        // =================================================
        // WHATSAPP URL
        // =================================================

        const whatsappURL =
            "https://wa.me/971501011783?text=" +
            encodeURIComponent(message.trim());


        // =================================================
        // OPEN WHATSAPP
        // =================================================

        window.open(
            whatsappURL,
            "_blank",
            "noopener,noreferrer"
        );

    };


    // =====================================================
    // RENDER
    // =====================================================

    return (

        <section className="city-tour">


            {/* =================================================
                HEADER
            ================================================= */}

            <div className="city-tour-header">

                <div className="city-tour-header-icon">

                    <i className="fa fa-map-marked-alt"></i>

                </div>


                <div>

                    <span className="city-tour-small-title">
                        PRIME LUXURY
                    </span>


                    <h1>
                        Dubai City Tours
                    </h1>


                    <p>
                        Discover Dubai in comfort with a
                        professional chauffeur and premium
                        luxury vehicle.
                    </p>

                </div>

            </div>



            {/* =================================================
                BOOKING CARD
            ================================================= */}

            <form
                className="city-tour-card"
                onSubmit={handleBooking}
            >


                {/* =================================================
                    CARD HEADER
                ================================================= */}

                <div className="city-tour-card-header">

                    <div>

                        <span className="city-tour-card-label">
                            CITY TOUR BOOKING
                        </span>


                        <h2>
                            Plan Your Dubai City Tour
                        </h2>

                    </div>


                    <div className="city-tour-card-icon">

                        <i className="fa fa-car"></i>

                    </div>

                </div>



                {/* =================================================
                    LOCATIONS
                ================================================= */}

                <div className="city-tour-section">


                    <div className="city-tour-section-title">

                        <span>
                            <i className="fa fa-map-marker"></i>
                        </span>


                        <div>

                            <strong>
                                Tour Locations
                            </strong>


                            <small>
                                Enter your pickup and destination
                            </small>

                        </div>

                    </div>



                    <div className="city-tour-grid">


                        {/* =================================================
                            PICKUP LOCATION
                        ================================================= */}

                        <div className="city-tour-form-group">

                            <label>
                                Pickup Location
                            </label>


                            <div className="city-tour-input-wrapper">

                                <span className="city-tour-input-icon">

                                    <i className="fa fa-map-marker"></i>

                                </span>


                                <input
                                    type="text"
                                    placeholder="Enter pickup location"
                                    value={pickup}
                                    onChange={(e) =>
                                        setPickup(e.target.value)
                                    }
                                    required
                                />

                            </div>

                        </div>



                        {/* =================================================
                            DESTINATION
                        ================================================= */}

                        <div className="city-tour-form-group">

                            <label>
                                Tour Destination
                            </label>


                            <div className="city-tour-input-wrapper">

                                <span className="city-tour-input-icon">

                                    <i className="fa fa-location-arrow"></i>

                                </span>


                                <input
                                    type="text"
                                    placeholder="Enter tour destination"
                                    value={destination}
                                    onChange={(e) =>
                                        setDestination(e.target.value)
                                    }
                                    required
                                />

                            </div>

                        </div>


                    </div>

                </div>



                {/* =================================================
                    TOUR DETAILS
                ================================================= */}

                <div className="city-tour-section city-tour-details">


                    <div className="city-tour-section-title">

                        <span>

                            <i className="fa fa-calendar"></i>

                        </span>


                        <div>

                            <strong>
                                Tour Details
                            </strong>


                            <small>
                                Select your preferred schedule
                            </small>

                        </div>

                    </div>



                    <div className="city-tour-grid">


                        {/* =================================================
                            TOUR DATE
                        ================================================= */}

                        <div className="city-tour-form-group">

                            <label>
                                Tour Date
                            </label>


                            <div className="city-tour-input-wrapper">

                                <span className="city-tour-input-icon">

                                    <i className="fa fa-calendar"></i>

                                </span>


                                <input
                                    type="date"
                                    value={tourDate}
                                    onChange={(e) =>
                                        setTourDate(e.target.value)
                                    }
                                    required
                                />

                            </div>

                        </div>



                        {/* =================================================
                            PICKUP TIME
                        ================================================= */}

                        <div className="city-tour-form-group">

                            <label>
                                Pickup Time
                            </label>


                            <div className="city-tour-input-wrapper">

                                <span className="city-tour-input-icon">

                                    <i className="fa fa-clock"></i>

                                </span>


                                <input
                                    type="time"
                                    value={tourTime}
                                    onChange={(e) =>
                                        setTourTime(e.target.value)
                                    }
                                    required
                                />

                            </div>

                        </div>



                        {/* =================================================
                            PASSENGERS
                        ================================================= */}

                        <div className="city-tour-form-group">

                            <label>
                                Passengers
                            </label>


                            <div className="city-tour-input-wrapper">

                                <span className="city-tour-input-icon">

                                    <i className="fa fa-users"></i>

                                </span>


                                <select
                                    value={passengers}
                                    onChange={(e) =>
                                        setPassengers(e.target.value)
                                    }
                                    required
                                >

                                    <option value="">
                                        Select Passengers
                                    </option>

                                    <option value="1 Passenger">
                                        1 Passenger
                                    </option>

                                    <option value="2 Passengers">
                                        2 Passengers
                                    </option>

                                    <option value="3 Passengers">
                                        3 Passengers
                                    </option>

                                    <option value="4 Passengers">
                                        4 Passengers
                                    </option>

                                    <option value="5 Passengers">
                                        5 Passengers
                                    </option>

                                    <option value="6+ Passengers">
                                        6+ Passengers
                                    </option>

                                </select>

                            </div>

                        </div>



                        {/* =================================================
                            TOUR DURATION
                        ================================================= */}

                        <div className="city-tour-form-group">

                            <label>
                                Tour Duration
                            </label>


                            <div className="city-tour-input-wrapper">

                                <span className="city-tour-input-icon">

                                    <i className="fa fa-hourglass-half"></i>

                                </span>


                                <select
                                    value={duration}
                                    onChange={(e) =>
                                        setDuration(e.target.value)
                                    }
                                    required
                                >

                                    <option value="">
                                        Select Duration
                                    </option>

                                    <option value="4 Hours">
                                        4 Hours
                                    </option>

                                    <option value="5 Hours">
                                        5 Hours
                                    </option>

                                    <option value="6 Hours">
                                        6 Hours
                                    </option>

                                    <option value="8 Hours">
                                        8 Hours
                                    </option>

                                    <option value="Full Day">
                                        Full Day
                                    </option>

                                </select>

                            </div>

                        </div>



                        {/* =================================================
                            VEHICLE TYPE
                        ================================================= */}

                        <div className="city-tour-form-group">

                            <label>
                                Vehicle Type
                            </label>


                            <div className="city-tour-input-wrapper">

                                <span className="city-tour-input-icon">

                                    <i className="fa fa-car"></i>

                                </span>


                                <select
                                    value={vehicle}
                                    onChange={(e) =>
                                        setVehicle(e.target.value)
                                    }
                                    required
                                >

                                    <option value="">
                                        Select Vehicle
                                    </option>

                                    <option value="Luxury Sedan">
                                        Luxury Sedan
                                    </option>

                                    <option value="Luxury SUV">
                                        Luxury SUV
                                    </option>

                                    <option value="Premium Van">
                                        Premium Van
                                    </option>

                                    <option value="Business Class">
                                        Business Class
                                    </option>

                                </select>

                            </div>

                        </div>


                    </div>

                </div>



                {/* =================================================
                    WHATSAPP BOOKING BUTTON
                ================================================= */}

                <div className="city-tour-button-wrapper">

                    <button
                        type="submit"
                        className="city-tour-book-button"
                    >

                        <i className="fab fa-whatsapp"></i>

                        Request City Tour

                    </button>

                </div>


            </form>



            {/* =================================================
                FEATURES
            ================================================= */}

            <div className="city-tour-features">


                {/* =================================================
                    FEATURE 1
                ================================================= */}

                <div className="city-tour-feature">

                    <div className="city-tour-feature-icon">

                        <i className="fa fa-map-marked-alt"></i>

                    </div>


                    <div>

                        <h3>
                            Explore Dubai
                        </h3>


                        <p>
                            Visit Dubai's famous attractions
                            with a private chauffeur.
                        </p>

                    </div>

                </div>



                {/* =================================================
                    FEATURE 2
                ================================================= */}

                <div className="city-tour-feature">

                    <div className="city-tour-feature-icon">

                        <i className="fa fa-user-tie"></i>

                    </div>


                    <div>

                        <h3>
                            Professional Chauffeur
                        </h3>


                        <p>
                            Enjoy comfortable and professional
                            chauffeur service throughout your tour.
                        </p>

                    </div>

                </div>



                {/* =================================================
                    FEATURE 3
                ================================================= */}

                <div className="city-tour-feature">

                    <div className="city-tour-feature-icon">

                        <i className="fa fa-car"></i>

                    </div>


                    <div>

                        <h3>
                            Premium Vehicles
                        </h3>


                        <p>
                            Choose from our range of luxury
                            vehicles for your Dubai tour.
                        </p>

                    </div>

                </div>


            </div>


        </section>

    );

}


export default CityTour;